import React, { useRef, useEffect } from 'react';
import { cn } from '../../utils/cn';

interface HoverCard3DProps {
  className?: string;
  children: React.ReactNode;
}

export const HoverCard3D: React.FC<HoverCard3DProps> = ({ className, children }) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const xRef = useRef(0);
  const yRef = useRef(0);
  const frameRef = useRef<number | null>(null);

  useEffect(() => {
    const animate = () => {
      if (!cardRef.current) return;

      const x = xRef.current;
      const y = yRef.current;

      cardRef.current.style.setProperty("--x", `${x}px`);
      cardRef.current.style.setProperty("--y", `${y}px`);

      frameRef.current = requestAnimationFrame(animate);
    };

    frameRef.current = requestAnimationFrame(animate);

    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
    };
  }, []);

  const handleMouseMove = (event: React.MouseEvent) => {
    const el = cardRef.current;
    if (!el) return;

    const rect = el.getBoundingClientRect();
    xRef.current = event.clientX - (rect.left + Math.floor(rect.width / 2));
    yRef.current = event.clientY - (rect.top + Math.floor(rect.height / 2));
  };

  const handleMouseLeave = () => {
    xRef.current = 0;
    yRef.current = 0;
  };

  return (
    <div className="[perspective:1200px] [transform-style:preserve-3d]">
      <div
        ref={cardRef}
        className={cn(
          "relative transition-transform duration-200 ease-out",
          className
        )}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{
          transform: "translate3d(calc(var(--x) / 10), calc(var(--y) / 10), 0)",
          transition: "transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        {children}
      </div>
    </div>
  );
}; 